import React from "react";
import { connect } from "react-redux";

import { bindActionCreators, Dispatch } from "@reduxjs/toolkit";

import { ActionBar, Sticky } from "@plex/react-components";

import { ActionBarLink } from "ui/app/navigation";
import { useLocalizedValues } from "ui/hooks";
import { releaseMessages } from "ui/screens/release/release.localization";

import { releasesManagerActions } from "../ReleasesManager.actions";
import { IReleasesManagerFilterData, IReleasesManagerState } from "../ReleasesManager.state";

interface IReleasesManagerActionBarProps {
  isSearched: boolean;
  search: (filterData?: IReleasesManagerFilterData) => void;
}

const ReleasesManagerActionBar: React.FC<IReleasesManagerActionBarProps> = ({ isSearched, search }) => {
  const localizedValues = useLocalizedValues(() => ({
    addReleaseAction: releaseMessages.action("addRelease")
  }));

  return (
    <Sticky>
      <ActionBar>
        <ActionBarLink
          openInDialog
          dialog={{
            to: {
              location: "/releases/create",
              data: {
                onReleaseAdded: () => {
                  isSearched && search();
                }
              }
            }
          }}
          text={localizedValues.addReleaseAction}
          title={localizedValues.addReleaseAction}
        />
      </ActionBar>
    </Sticky>
  );
};

export default connect(
  (state: { releasesManager: IReleasesManagerState }) => {
    return {
      isSearched: state.releasesManager.grid.isSearched
    };
  },
  (dispatch: Dispatch) => {
    return bindActionCreators(
      {
        search: releasesManagerActions.search
      },
      dispatch
    );
  }
)(ReleasesManagerActionBar);
